import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { getObjectListByPropertyApi } from 'api/general';
import { getSubjectName, stripHTMLTags } from 'app/utils/appHelpers';
import { DECISION } from 'app/utils/constants/customConstant';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PendingAgendaDataTableToolbar from './PendingAgendaDataTableToolbar';

function PendingAgendaDataTable({ handleAddPendingAgenda }) {

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [loading, setLoading] = useState(false);
  const subjectList = useSelector(state => state.subject.data || []);
  const [selectedDecision, setSelectedDecision] = useState({});
  const allAuthorizedUnits = useSelector(state => state.auth.allAuthorizedUnits);
  const pageType = useSelector(state => state.meeting.pageType);

  const tableCellStyle = { fontSize: '12px' };
  const commonColumnStyle = { ...tableCellStyle, minWidth: 45, maxWidth: 45 };
  const column = [

    { id: 'department', align: 'left', disablePadding: false, label: "İlgili Kurum/Birim" },
    { id: 'subject', align: 'left', disablePadding: true, label: "Konu" },
    { id: 'agenda', align: 'left', disablePadding: true, label: "Gündem" },
    { id: 'decision', align: 'left', disablePadding: true, label: "Karar" },
    { id: 'action', align: 'left', disablePadding: false, label: "İşlem" },

  ];

  // unit idye göre olanı sor????

  useEffect(() => {
    const getAPI = async () => {
      setLoading(true);
      try {

        let agendas = [];
        agendas = await getObjectListByPropertyApi(DECISION, "meetingId", "-1");
        agendas = agendas.data;
        agendas = agendas.filter(agenda => agenda.pendingUnitId !== 0);

        let units = [];
        if (pageType === "1") {
          units = allAuthorizedUnits.filter(x => x.inst === "YK")
        } else if (pageType === "3") {
          units = allAuthorizedUnits.filter(x => x.inst !== "YK")
        }

        agendas = agendas.filter(agenda => units.map(unit => unit.id).includes(agenda.pendingUnitId));

        setData(agendas);
        setData2(agendas);


      } catch (error) {
        console.error("API Hatası: ", error);
      } finally {
        setLoading(false);
      }
    };

    getAPI();
  }, []);


  const handleRequestSort = (event, property) => {
    const tempOrderBy = property;
    let tempOrder = 'desc';

    if (orderBy === property && order === 'desc') {
      tempOrder = 'asc';
    }

    const tempdata =
      tempOrder === 'desc'
        ? data.sort((a, b) => (b[tempOrderBy] < a[tempOrderBy] ? -1 : 1))
        : data.sort((a, b) => (a[tempOrderBy] < b[tempOrderBy] ? -1 : 1));

    setData(tempdata);
    setOrder(tempOrder);
    setOrderBy(tempOrderBy);

  };

  const DataTableHead = ({ onRequestSort, customColumnData }) => {
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };
    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => (
            <TableCell
              key={column.id}
              align={column.align}
              padding={column.disablePadding ? 'none' : 'normal'}
              sx={column.sx}  // sx özelliklerini uyguluyoruz
            >
              <Tooltip
                title="Sırala"
                placement={column.align === 'right' ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={createSortHandler(column.id)}
                >
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };


  const onAddPendingAgenda = async (item) => {
    setSelectedDecision(item);
    if (handleAddPendingAgenda) {
      handleAddPendingAgenda(item);
    }
  };
  const onClickAddPending = async (n) => {
    await onAddPendingAgenda(n)
  };

  // const afterUpdateFunc = (updatedFields, recordId) => {
  //   const updatedData = data.map(item =>
  //     item.id === recordId ? { ...item, ...updatedFields } : item
  //   );
  //   setData([...updatedData]);
  //   setData2([...updatedData]);

  // };


  return (
    <Paper className="col-md-12">

      <PendingAgendaDataTableToolbar
        pageTitle={"Askıdaki Gündemler"}
        data2={data2}
        setData={setData}
        loading={loading}
        setLoading={setLoading}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <CircularProgress />
        </div>
      ) : (
        <>


          <div className="flex-auto">
            <div className="table-responsive-material">
              <Table className="">
                <DataTableHead
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={data.length}
                  customColumnData={column}
                />

                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((n) => {


                      return (
                        <TableRow hover key={"trO" + n.id}>


                          <TableCell align="left" padding="normal" >
                            {n.department}
                          </TableCell>
                          <TableCell align="left" padding="none" >
                            {getSubjectName(n.subjectId, subjectList)}
                          </TableCell>
                          <TableCell align="left" padding="none" sx={{ whiteSpace: 'pre-line' }}>
                            {stripHTMLTags(n.agenda)}
                          </TableCell>
                          <TableCell align="left" padding="none" sx={{ whiteSpace: 'pre-line' }}>
                            {stripHTMLTags(n.decision)}
                          </TableCell>

                          <TableCell align="left" padding="none" >

                            <Tooltip title="Toplantıya Ekle">
                              <Button
                                variant="contained"
                                size="small"
                                sx={{ minWidth: 20, p: '5px' }}
                                onClick={() => onClickAddPending(n)}
                              >
                                Ekle
                              </Button>

                            </Tooltip>
                          </TableCell>

                        </TableRow>
                      );
                    })}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      count={data.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={(e, page) => setPage(page)}
                      onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                      labelRowsPerPage={"Görüntülenecek Satır"}
                      rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                      showFirstButton
                      showLastButton
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </div>

          {/* <PendingMeetingDataTableDialog
            selectedDecision={selectedDecision}
            open={dstatusDialogStatus}
            onClose={() => setMeetingDataTableStatus(false)}
            afterUpdateFunc={afterUpdateFunc}
          /> */}


        </>
      )}
    </Paper>
  );
};

export default PendingAgendaDataTable;